import React from 'react';
import { C } from '../styles';
import type { Section, Employee } from '../types';

interface Props {
  section: Section;
  isOpen: boolean;
  onToggleOpen: () => void;
  employee: Employee;
  onEditClick: () => void;
}

function fmt(v: unknown): string {
  if (v === null || v === undefined || v === '') return '-';
  const s = String(v).replace(/[$,\s]/g, '');
  const n = parseFloat(s);
  if (isNaN(n)) return '-';
  const parts = n.toFixed(2).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return '$' + parts.join('.');
}

function yn(v: unknown): 'Yes' | 'No' {
  if (v === true || v === 'Yes') return 'Yes';
  return 'No';
}

export default function TaxSectionCard({ section, isOpen, onToggleOpen, employee, onEditClick }: Props) {
  const ti = (employee && (employee as any).tax_info) || {};
  const province = (ti.provinceEmp || '').toUpperCase();
  const anyExempt =
    yn(ti.cppExempt) === 'Yes' ||
    yn(ti.eiExempt) === 'Yes' ||
    yn(ti.fedTaxExempt) === 'Yes';

  return (
    <div style={{
      background: '#FFFFFF',
      border: '1px solid ' + C.line,
      borderRadius: 12,
      marginBottom: 12,
    }}>
      <div
        style={{ display: 'flex', alignItems: 'center', padding: '16px 20px', cursor: 'pointer' }}
        onClick={onToggleOpen}
      >
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: C.ink }}>{section.title}</div>
        </div>
        <a
          onClick={(e) => { e.stopPropagation(); onEditClick(); }}
          style={{
            color: C.tealInk, fontWeight: 700, fontSize: 13,
            textDecoration: 'underline', cursor: 'pointer', marginRight: 12,
          }}
        >
          {(!ti.federalTD1 && !ti.provincialTD1) ? 'Start' : 'Edit'}
        </a>
        <span style={{ color: C.muted, fontSize: 14 }}>{isOpen ? '▾' : '▸'}</span>
      </div>
      {isOpen && (
        <div style={{ padding: '4px 20px 18px', borderTop: '1px solid ' + C.line }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '10px 24px',
            padding: '12px 0',
          }}>
            <span style={{ fontSize: 13.5, color: '#12262B', fontWeight: 700 }}>Province of employment</span>
            <span style={{ fontSize: 13.5, color: C.ink, fontWeight: 500 }}>{province || '-'}</span>

            <span style={{ fontSize: 13.5, color: '#12262B', fontWeight: 700 }}>Federal TD1 amount</span>
            <span style={{ fontSize: 13.5, color: C.ink, fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>{fmt(ti.federalTD1)}</span>

            <span style={{ fontSize: 13.5, color: '#12262B', fontWeight: 700 }}>Provincial TD1 amount</span>
            <span style={{ fontSize: 13.5, color: C.ink, fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>{fmt(ti.provincialTD1)}</span>

            <span style={{ fontSize: 13.5, color: '#12262B', fontWeight: 700 }}>Additional tax per pay</span>
            <span style={{ fontSize: 13.5, color: C.ink, fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>{fmt(ti.additionalTax)}</span>

            <span style={{ fontSize: 13.5, color: '#12262B', fontWeight: 700 }}>Exemptions</span>
            <span style={{ fontSize: 13.5, color: C.ink, fontWeight: 500 }}>
              {anyExempt
                ? [
                    yn(ti.cppExempt) === 'Yes' ? 'CPP' : null,
                    yn(ti.eiExempt) === 'Yes' ? 'EI' : null,
                    yn(ti.fedTaxExempt) === 'Yes' ? 'Federal tax' : null,
                  ].filter(Boolean).join(', ')
                : 'None'}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}